import { useLocation } from "react-router-dom";
import { connect } from "react-redux";

//PROJECT IMPORTS
import AddFixedDepositCharge from "./AddFixedDepositCharge";
import ApproveAccount from "./ApproveAccount";
import UndoApproval from "./UndoApproval";
import ActivateFixedDepositAcc from "./ActivateFixedDepositAcc";
import RejectFixedDepositAcc from "./RejectFixedDepositAcc";
import ModifyFixedDepositAccount from "./ModifyFixedDepositAccount";
import ManageAccount from "./ManageAccount";
import PrematureCloseFixedDepositAcc from "./PrematureCloseFixedDepositAcc";
import CloseFixedDepositAcc from "./CloseFixedDeposit";
import WithdrawnByClientFixedDepositAcc from "./WithdrawnByClientFixedDepositAcc";

const CallDepositsMainActionPage = (props) => {
  const { userData } = props;
  const { state } = useLocation();

  const renderActions = () => {
    switch (state?.actionLabel?.toLowerCase()) {
      case "modify application":
        return <ModifyFixedDepositAccount userData={userData} />;
      case "add charge":
        return <AddFixedDepositCharge userData={userData} />;
      case "manage account":
        return <ManageAccount userData={userData} />;
      case "undo approval":
        return <UndoApproval userData={userData} />;
      case "approve":
        return <ApproveAccount userData={userData} />;
      case "activate":
        return <ActivateFixedDepositAcc userData={userData} />;
      case "reject":
        return <RejectFixedDepositAcc userData={userData} />;
      case "premature close":
        return <PrematureCloseFixedDepositAcc userData={userData} />;
      case "close":
        return <CloseFixedDepositAcc userData={userData} />;
      case "withdrawn by applicant":
        return <WithdrawnByClientFixedDepositAcc userData={userData} />;
      default:
        return <>No {state.actionLabel} Component found contact dev</>;
    }
  };
  return <>{renderActions()}</>;
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
});
export default connect(mapStateToProps, null)(CallDepositsMainActionPage);
